import {React, useEffect, useRef, useState} from 'react';
import { useTranslation }    from "react-i18next";

import SwipeableDrawer from '@mui/material/SwipeableDrawer';


// Fragments:
import FilterView from '../../../Fragments/Filter/FilterView';
import ObjDetailView from '../../../Fragments/ObjectDetail/ObjectDetailView';

// MUI Components:
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';

// Styled comp:
import { styled } from '@mui/material/styles';

// theme
import {themeParams} from '../../../theme/themeParams';


function CustomDrawer({openDrawer,closeDrawer, sParam, currObjId, onFilterClose}) {

    const [sViewParam, setParam] = useState(sParam);

    const SwipeLine = styled(Box) ({
        width:'30%',
        backgroundColor:'#808080',
        height:'0.5rem',
        display:'block',
        marginTop:'1px',
        marginBottom:'1px',
        borderRadius:'5rem',
        opacity: 0.9
    });

    const SwipeLineContainer =  styled(Box)({
        display: 'flex',
        flexDirection:'column',
        alignItems:'center',
        [`& ${SwipeLine}`]: {

        }

        // [themeParams.mediaLGUp]: {
        //    width:'100%'
        // }

    });



    const DrawerContainer = styled(Box) ({
        height: '92vh',
        [`& ${SwipeLineContainer}`]: {
            
        }

        // [themeParams.mediaLGUp]: {
        //    width:'100%'
        // }


    });

    const ref = useRef();

        return(
            <SwipeableDrawer
                ref={ref}
                anchor='bottom'
                open={openDrawer}
                // onOpen={handleDrawerOpen}
                onClose={closeDrawer}>
            <DrawerContainer>
                <SwipeLineContainer><SwipeLine></SwipeLine></SwipeLineContainer>

                {( () => {
                    switch (sParam) { //sParam
                    case 'fltr':
                        return <FilterView onFilterClose={onFilterClose}></FilterView>
                    case 'objdet':
                        return <ObjDetailView currObjId={currObjId}></ObjDetailView>
                    default:
                        return null
                    }
                }) ()}


            </DrawerContainer>
                
            </SwipeableDrawer>
        )
}

export default CustomDrawer;